import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Hoş geldin."); nav("/admin"); }
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-green grain relative overflow-hidden px-6">
      <div className="relative w-full max-w-md bg-brand-offwhite rounded-sm p-10 border border-brand-gold-light/40">
        <div className="text-center mb-8">
          <div className="font-serif text-3xl font-semibold text-brand-green">BİLGECE<span className="text-brand-gold align-super text-base">™</span></div>
          <p className="text-brand-text/60 text-sm mt-2">Yönetim Paneli</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-brand-text mb-1.5">E-posta</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
              className="w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold" />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-text mb-1.5">Şifre</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
              className="w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold" />
          </div>
          {error && <p className="text-red-700 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-green transition-colors px-4 py-3 text-sm font-semibold rounded-sm disabled:opacity-60">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
